export var ExecutionStage;
(function (ExecutionStage) {
    ExecutionStage["before"] = "before";
    ExecutionStage["around"] = "around";
    ExecutionStage["return"] = "return";
    ExecutionStage["throw"] = "throw";
    ExecutionStage["after"] = "after";
    ExecutionStage["protect"] = "protect";
})(ExecutionStage || (ExecutionStage = {}));
//# sourceMappingURL=execution.js.map